module.exports = "<div class=\"container\">\n  <h1>Welcome to Xpo Auth User Management</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/dashboard/dashboard.component.html
// module id = ../../../../../src/app/dashboard/dashboard.component.html
// module chunks = main